<template>
  <div
    v-if="transaction.warnings && transaction.warnings.length > 0 && showWarnings"
    class="transaction-warnings"
    :class="extraClass"
  >
    <template v-for="warning in transaction.warnings">
      <div
        v-if="!warning.ignored && warning.type.code !== 'AMOUNT_EXCHANGE_WRONG'"
        :key="warning.id"
        class="transaction-warning-container"
      >
        <div class="transaction-warning">
          <img
            class="transaction-warning-icon"
            alt="transaction-warning-icon"
            :src="require(`@/assets/img/icons/icon-warning.svg`)"
          />
          <span class="transaction-warning-text">{{ $t(`transaction_warning_${warning.type.code}`) }}
            <info-display
              v-if="warning.type.code === 'DUPLICATE'"
              :class="'icon-info'"
              :infoText="$t('transaction_warning_duplicate_tooltip')"
            />
          </span>
          <span
            class="transaction-warning-ignore clickable"
            @click="showIgnoreWarning(warning)"
          >{{ $t('transaction_warning_ignore') }}</span>
        </div>
        <div
          v-if="warning.type.code === 'DUPLICATE'"
          class="transaction-warning-duplicate"
        >
          <div
            v-for="(duplicate, index) in warning.relatedTransactionIds"
            :key="duplicate"
            class="d-flex justify-content-between"
          >
            <span class="transaction-warning-duplicate-text">{{$t('transaction_warning_duplicate_text', {index: index})}}</span>
            <span
              class="clickable transaction-warning-duplicate-link"
              @click="showTransactionModal(duplicate)"
            >{{$t('transaction_warning_duplicate_link')}}</span>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import InfoDisplay from '@/components/Commons/InfoDisplay'

export default {
  components: {
    InfoDisplay
  },
  props: {
    transaction: {
      type: Object,
      default: () => { }
    },
    extraClass: {
      type: String,
      default: ''
    }
  },
  computed: {
    showWarnings () {
      return this.$route.name !== 'my_charged_transactions' && this.$route.name !== 'my_authorizations_transactions' && this.$route.name !== 'my_declined_transactions' && this.$route.name !== 'my_pending_reimbursements' && this.$route.name !== 'my_history_reimbursements'
    }
  },
  methods: {
    showIgnoreWarning (warningToIgnore) {
      this.$emit('showIgnoreWarning', warningToIgnore)
    },
    showTransactionModal (transactionId) {
      this.$emit('showTransactionModal', { id: transactionId })
    }
  }
}
</script>

<style lang="scss" scoped>
.transaction-detail-warning.transaction-warnings {
  margin-top: 17px;
  .transaction-warning-container {
    background-color: var(--fill-text-area);
  }
}
.transaction-warnings {
  width: 100%;
  margin-top: 25px;
  .transaction-warning-container {
    padding: 7px 8px 7px;
    border: 1px solid var(--fill-divider);
    border-radius: 4px;
    &:not(:last-child) {
      margin-bottom: 8px;
    }
    .transaction-warning {
      display: flex;
      &-text {
        flex: 1;
        margin-left: 8px;
        color: var(--text-body);
        font-weight: 400;
        font-size: 13px;
        line-height: 24px;
      }
      &-ignore {
        flex: 0;
        font-weight: 500;
        font-size: 13px;
        line-height: 24px;
        color: var(--blue);
      }
      &-duplicate {
        margin-top: 8px;
        padding-top: 8px;
        border-top: 1px solid var(--fill-divider);
        div:not(:last-child) {
          margin-bottom: 8px;
        }
      }
      &-duplicate-text {
        font-size: 15px;
        line-height: 24px;
      }
      &-duplicate-link {
        display: flex;
        align-items: center;
        color: var(--text-link);
        font-size: 13px;
        font-weight: 500;
        line-height: 24px;
        &:after {
          content: "";
          display: inline-block;
          width: 16px;
          height: 16px;
          margin-left: 4px;
          margin-bottom: -3px;
          background-image: url("~@/assets/img/icons/icon-arrow-right-blue.svg");
          background-repeat: no-repeat;
          background-position: center;
        }
      }
    }
  }
}
</style>
